// extracted by mini-css-extract-plugin
export default {"mobileMenu":"mobile-navbar_mobileMenu__3ul2g"};